import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge14 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='法人無記名式のゴルフの会員権とは' fontWeight={700} />
                <p>
                    ゴルフ会員権の法人会員には「無記名式」と「記名式」があります。
                    <br />
                    個人会員であれば、個人名義での購入になるため全て記名式になるのでその本人のみのプレーになりますが、法人会員ではその法人に属する人であれば誰でもプレー可能な無記名式の会員権を発行しているゴルフ場があります。
                    <br />
                    法人会員でもプレーする人を指定する法人記名式の会員権が発行されており、無記名式の方が便利ではありますが、実際に法人無記名式のゴルフ会員権を発行しているのは限られたごく一部のゴルフ場です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='【法人ゴルフ会員権】法人無記名式と法人記名式の違い' fontWeight={700} />
                <p>では具体的に、法人会員の「無記名式」と「記名式」にはどんな違いがあるのかご紹介します。</p>

                <Heading3 title='無記名式の特徴' />
                <p>
                    法人無記名式は前述のとおり、その法人に属する人なら誰でも利用可能ため、とても便利でよく利用されていました。
                    <br />
                    １９８５年頃までは数も多く売買も行われていましたが、現在では無記名式の会員権はほとんど発行されておらず、無記名式で発行されたゴルフ会員権は売買や譲渡時の名義書換の際に、記名式に変更されるケースがほとんどです。
                    <br />
                    無記名式が減った理由としては、利用規約で禁止されている会員権の貸し借りを行う会員が出てきたことに原因があります。
                    <br />
                    会員権を所有している法人以外の法人に貸し出すなどでゴルフ場が被害を受けたことによって多くのゴルフ場が廃止しました。
                    <br />
                    法人ゴルフ会員権の無記名式は記名式に比べると、購入料金がやや高めに設定されている点も特徴の１つです。
                    <br />
                    現在もなお無記名式会員権を発行しているゴルフ場としては、神奈川カントリークラブや東京国際空港ゴルフ倶楽部などが挙げられます。
                    <br />
                    無記名式の仕組みや購入・売却時の注意点についてさらに詳しくは
                    <a href='/knowledge/24'>無記名式ゴルフ会員権とは？記名式との違いやメリット・デメリットを解説</a>
                    でご紹介していますので、あわせてご参照ください。
                </p>

                <Heading3 title='記名式の特徴' />
                <p>
                    現在ほとんどのゴルフ場で採用されているのが記名式です。
                    <br />
                    記名式会員権は１名のみ利用可能な１名記名式から複数人が記名されているものがあり、会員権代金は記名人数に比例しており、２名記名式なら個人会員の２倍、１名のみであれば個人会員と同等の料金になります。
                    <br />
                    ※法人会員権と個人会員権に価格差のあるゴルフ場もあります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='法人でゴルフ会員権を持つメリット【法人無記名式・法人記名式】' fontWeight={700} />
                <p>
                    法人会員権を持つメリットは費用や、優先的にプレーできるなど様々ありますが、主なメリットは以下のとおりです。
                    <br />
                    <br />
                    ・年会費、プレー料金、ロッカー代等が経費として計上できる
                    <br />
                    ・プレー料金がビジター料金より安い
                    <br />
                    ・プレー予約の優先権がある
                    <br />
                    ・会社のステータスになる
                    <br />
                    ・記名式の場合、同一法人内での名義書換料が個人の半額程度になるケースが多い
                </p>

                <Heading3 title='年会費・プレー料金・ロッカー代などが経費として計上できる' />
                <p>
                    法人会員権の購入代金は資産計上できます。購入代金が資産として計上されている場合、年会費やプレー料金、ロッカー代等の費用は交際費となり、経費計上できます。
                </p>

                <Heading3 title='プレー料金がビジター料金より安い' />
                <p>
                    会員になると、ビジターよりも安くプレーできます。土日は高いところで３万円以上、安いところでも１万円以上かかりますが、会員になると半分以下の料金でプレーできる場合が多くなります。
                    <br />
                    この料金差は都市部であるほど大きく、特に東京・神奈川でプレーする場合は料金面のメリットは大きくなります。
                </p>

                <Heading3 title='プレー予約の優先権がある' />
                <p>
                    ゴルフ会員権にはプレー予約の優先権が付随していますので、直前のプレーであってもビジター会員より予約が取りやすいメリットがあります。
                    <br />
                    急な接待などが決まった際にもスムーズに予約が取れるようになります。
                </p>

                <Heading3 title='会社のステータスになる' />
                <p>
                    ゴルフ会員権は高額なものもあるため、会社のステータスになります。
                    <br />
                    会員権と名義書換料だけで数千万円かかるゴルフ場もあり、なかなか個人では会員になれないケースが多く、その様な会員権の保有が「信用力の証」という風潮は、今でも富裕層の間では残っています。
                </p>

                <Heading3 title='記名式の場合、同一法人内での名義書換料が個人の半額程度になるケースが多い' />
                <p>
                    名義書換料は１０万円～１００万円、高い場合には１０００万円以上する等とても高額ですが法人記名式会員の場合は、個人会員の名義書換料の半額程度で名義書換が可能な場合が多く、会社役員などがゴルフ会員権を購入する場合には一般的に法人会員を選びます。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='法人でゴルフ会員権を持つデメリット【法人無記名式・法人記名式】' fontWeight={700} />
                <p>
                    続いて、法人でゴルフ会員権を持つデメリットについてみていきます。
                    <br />
                    法人でゴルフ会員権を持つデメリットは維持費や価格の下落など、以下のような項目が挙げられます。
                    <br />
                    <br />
                    ・維持費がかかる
                    <br />
                    ・記名式で分割不可の場合、記名人数分の需要がないと売却できない場合がある
                    <br />
                    ・ゴルフ会員権の価格下落により、売却損になる可能性がある
                </p>

                <Heading3 title='維持費がかかる' />
                <p>
                    ゴルフ会員権には年会費等の維持費がかかります。
                    <br />
                    １０万円を超える年会費が必要なゴルフ場もあるため、あまり利用しないのであれは損失が発生する可能性があるので注意が必要です。
                </p>

                <Heading3 title='記名式で分割不可の場合、記名人数分の需要がないと売却できない場合がある' />
                <p>
                    ゴルフ会員権は売却が可能ですが、記名式の場合、人数分の需要がないと売却出来ない場合があります。
                    <br />
                    2名記名式会員権を１名ずつに分割できるケースもありますが、別途手数料が必要なこともあります。
                </p>

                <Heading3 title='ゴルフ会員権の価格下落により、売却損になる可能性がある' />
                <p>
                    ゴルフ会員権の価格は変動するため、価格が下落すると売却損になる可能性があります。
                    <br />
                    売却の際には、実績のある会員権業者を選ばなければ、大きな売却損が発生する可能性が高いため、会員権業者を選ぶ際は慎重に比較検討しましょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2
                    title='【ゴルフ会員権】法人無記名式・法人記名式の売買は、住地ゴルフにお任せください'
                    fontWeight={700}
                />
                <p>
                    法人ゴルフ会員権には記名式と無記名式があり、無記名式はその法人に属する人であれば誰でも利用可能なためとても便利ですが、その数は非常に少なくなっています。
                    <br />
                    法人会員権には様々なメリットがありますが、売買する際は、大きな損を発生させないように注意が必要です。会員権売買をご検討中の方は、「住地ゴルフ」にご相談ください。
                    <br />
                    確かな実績に基づく豊富な経験があるからこそ、お役に立てることがあると思います。ぜひ一度、お気軽にお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge14;
